import React from 'react';
import qualizLogo from '../assets/qualiz-logo.svg';

export const QualizLogo = ({ className = '', size = 24, alt = 'Qualiz Logo' }) => {
  return (
    <img src={qualizLogo} alt={alt} className={className} style={{ width: size, height: size }} />
  );
};
